var render = function render(){var _vm=this,_c=_vm._self._c;return _c('body',{style:({ backgroundColor: _vm.inisVl })},[_c('div',{staticClass:"container",staticStyle:{"overflow-x":"hidden","overflow-y":"hidden","padding-right":"0px","padding-left":"0px"},attrs:{"id":"app"}},[_c('nav-bar'),_c('router-view'),_c('Footer')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }